// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * @hidden
 */
export type StatusCode = number;
/**
 * @hidden
 */
export type SubStatusCode = number;
